import axiosInstance from "./axiosInstance.ts";

export interface createVoucherWithThirdsParams {
  third: {
    phoneNumber: number | string;
  };
  voucher: {
    amount: number;
    quantity: number;
  };
  service: {
    reference: string | undefined;
  };
}

export const getEvents = async () => {
  const response = await axiosInstance.get("/events/partner", {
    headers: {
      isActif: true,
    },
  });
  return response.data;
};

export const getEventsByCategories = async (categoryReference: string) => {
  const response = await axiosInstance.get(
    `events/partner?categoryReference=${categoryReference}`
  );
  return response.data;
};

export const getEventsDetails = async (enventReference: string) => {
  const response = await axiosInstance.get(`events/details/${enventReference}`);
  return response.data;
};

export const getThirdVouchers = async (thirdPhoneNumber: string) => {
  const response = await axiosInstance.get(`/third_vouchers`, {
    headers: {
      thirdPhoneNumber,
      referencePartner: import.meta.env.VITE_VMS_APP_PARTNER_REF
    },
  });
  return response.data;
};

export const createVoucherWithThirds = async (
  data: createVoucherWithThirdsParams
) => {
  const response = await axiosInstance.post(`/voucher/third`, data);
  return response.data;
};

export const groupTicketsByEvents = (originalArray: any[]) => {
  const newArray = originalArray?.reduce((acc, ticket) => {
    const event = ticket?.service?.events;
    const existingEvent = acc?.find(
        (item: { event: { reference: any } }) =>
            item?.event?.reference === event?.reference
    );

    if (existingEvent) {
      existingEvent?.tickets?.push(ticket);
    } else {
      acc?.push({
        event: event,
        tickets: [ticket],
      });
    }
    return acc;
  }, []);

  // Trier les événements par date décroissante (assumant que `event.date` est un timestamp ou une date valide)
  return newArray?.sort(
      (a: { event: { eventDate: string | number | Date; }; }, b: { event: { eventDate: string | number | Date; }; }) => new Date(b?.event?.eventDate).getTime() - new Date(a?.event?.eventDate).getTime()
  );
};

